import React                    from 'react';
import PropTypes                from 'prop-types';
import { useTranslation }       from 'react-i18next';
import useStyles                from './styles';
import Dialog                   from '~/components/Dialog';

function ModalImage(props) {
  const { modal, onClose, url } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Dialog
      isOpen={modal}
      onClose={onClose}
      handleClose={onClose}
      notFullScreen={true}
      title={t('tour.extras.tour_image_preview')}
    >
      <div className={classes.root}>
          <img src={url} className={classes.img}/>
      </div>
    </Dialog>
  );
}

ModalImage.propTypes = {
  url: PropTypes.string,
  modal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default ModalImage;
